import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Stack,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import api from "../../../services/api";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const EditableFulfillmentInfo = ({ order, setOrder }) => {
  const { method, date, time, location } = order.fulfillment;
  const [storeLocations, setStoreLocations] = useState([]);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const res = await api.get("/admin/stores");
        setStoreLocations(res.data || []);
      } catch (err) {
        console.error("Failed to fetch store locations", err);
      }
    };

    fetchLocations();
  }, []);

  const handleChange = (field, value) => {
    setOrder({
      ...order,
      fulfillment: { ...order.fulfillment, [field]: value },
    });
  };

  const TIME_OPTIONS = [
    "9:00 AM",
    "9:30 AM",
    "10:00 AM",
    "10:30 AM",
    "11:00 AM",
    "11:30 AM",
    "12:00 PM",
    "12:30 PM",
    "1:00 PM",
    "1:30 PM",
    "2:00 PM",
    "2:30 PM",
    "3:00 PM",
    "3:30 PM",
    "4:00 PM",
    "4:30 PM",
    "5:00 PM",
    "5:30 PM",
    "6:00 PM",
    "6:30 PM",
  ];

  return (
    <Box p={2}>
      <Typography variant="h6" gutterBottom>
        Fulfillment Info
      </Typography>

      <Stack spacing={2} mt={2}>
        <RadioGroup
          row
          value={method}
          onChange={(e) => handleChange("method", e.target.value)}>
          <FormControlLabel value="pickup" control={<Radio />} label="Pickup" />
          <FormControlLabel
            value="delivery"
            control={<Radio />}
            label="Delivery"
          />
        </RadioGroup>

        <TextField
          label="Scheduled Date"
          type="date"
          fullWidth
          value={
            date ? dayjs(date).tz("America/St_Johns").format("YYYY-MM-DD") : ""
          }
          onChange={(e) => {
            const selectedDate = dayjs
              .tz(`${e.target.value}T00:00:00`, "America/St_Johns")
              .toISOString(); // this stores the exact Newfoundland midnight
            handleChange("date", selectedDate);
          }}
        />

        <FormControl fullWidth>
          <FormControl fullWidth>
            <InputLabel>Time</InputLabel>
            <Select
              label="Pickup Time"
              fullWidth
              value={time || ""}
              onChange={(e) => handleChange("time", e.target.value)}
              MenuProps={{
                PaperProps: { sx: { maxHeight: 400, mt: 0.5 } },
                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                transformOrigin: { vertical: "top", horizontal: "left" },
              }}>
              {TIME_OPTIONS.map((t) => (
                <MenuItem key={t} value={t}>
                  {t}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </FormControl>

        {method === "pickup" ? (
          <FormControl fullWidth>
            <InputLabel>Pickup Location</InputLabel>
            <Select
              value={location || ""}
              label="Pickup Location"
              onChange={(e) => handleChange("location", e.target.value)}>
              {storeLocations.map((loc) => (
                <MenuItem key={loc._id} value={loc.address}>
                  {loc.address}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          <TextField
            label="Delivery Address"
            fullWidth
            value={location || ""}
            onChange={(e) => handleChange("location", e.target.value)}
          />
        )}
      </Stack>
    </Box>
  );
};

export default EditableFulfillmentInfo;
